import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Kein Element mit der Id "root" gefunden – index.html prüfen.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
